import React from 'react';
import { StaticImageData } from 'next/image';
import { YouTubeEmbed } from '@next/third-parties/google';

import type { TableProps } from 'Components/Table';

import { Container, ContentPlaceholder, StyledLink, FigureCaption } from './Video.styled';

export interface Props {
    id?: string;
    title?: string; // TODO: will need to be required once all videos swapped to transcriptEmbed
    video: {
        src: string;
        title?: string;
    };
    image: {
        src: StaticImageData | string;
        alt?: string;
        priority?: boolean;
    };
    caption?: string;
    transcript?: TableProps;
    transcriptUrl?: string; //TODO: will need to be changed to required once all videos swapped
}

const Video: React.FC<Props> = props => {
    const { id, image, video, title, caption, transcript, transcriptUrl } = props;

    const videoId = video.src.match(/embed\/([^?]+)/);

    return videoId ? (
        <Container id={id} className="c-video">
            {caption && <FigureCaption>{caption}:</FigureCaption>}
            <ContentPlaceholder>
                <YouTubeEmbed
                    videoid={videoId[1]}
                    playlabel={`Play ${video.title} video`}
                    style={`position: absolute; top: 0; left: 0; width: 100%; height: 100%; border-radius: 0.5rem; max-width: 100%; background-image: url(${image.src});`}
                />
            </ContentPlaceholder>
            {transcript && transcriptUrl && transcript.tableRows.length >= 1 && (
                <StyledLink
                    href={transcriptUrl}
                    openInNewTab={true}
                    ariaLabel={`Open transcript video page for ${title}`}
                >
                    Video transcript, with a description of visuals available.
                </StyledLink>
            )}
        </Container>
    ) : null;
};

export default Video;
